document.addEventListener("turbo:load", initTabs)
document.addEventListener("turbo:frame-load", initTabs)

function resolveTabElement(candidate) {
  if (candidate instanceof Element) return candidate
  if (candidate?.jquery && candidate[0] instanceof Element) return candidate[0]
  return null
}

function initTabs() {
  if (typeof bootstrap === "undefined" || !bootstrap?.Tab?.getOrCreateInstance) return

  document.querySelectorAll('[data-bs-toggle="tab"], [data-bs-toggle="pill"]').forEach((candidate) => {
    const el = resolveTabElement(candidate)
    if (!el) return

    const target = el.getAttribute("data-bs-target") || el.getAttribute("href")
    if (target && target.startsWith("#") && !document.querySelector(target)) return

    try {
      bootstrap.Tab.getOrCreateInstance(el)
    } catch (error) {
      console.warn("Skipping invalid tab toggle element", error)
    }
  })
}
